import { useLocation } from 'react-router';
import { SideNavigationItems } from '../../../config/side-nav.config';
import './side-nav.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

export const SideNavigation = () => {
	/* variables */
	const location = useLocation();
	const items = SideNavigationItems.flatMap((group) => group.items);
	const activeIndex = items.findIndex(
		(item) => item.link === location.pathname,
	);

	return (
		<nav className='w-full bg-canvas px-[1.2rem] py-[2rem]'>
			<div className='px-[1.2rem] pb-[1.2rem] font-montserrat text-[1.2rem] font-semibold tracking-[0.14em] text-gray-500'>
				YOUR PROGRESS
			</div>
			<ul className='flex flex-col gap-[0.4rem]'>
				{items.map((item, index) => {
					const isActive = index === activeIndex;
					const isDone = activeIndex > -1 && index < activeIndex;

					return (
						<li key={index}>
							<div
								className={`flex items-center gap-[1.2rem] rounded-xl px-[1.2rem] py-[1.1rem] transition-colors duration-150 ${
									isActive
										? 'bg-secondary-50'
										: 'hover:bg-gray-100'
								}`}
							>
								<span
									className={`flex h-[3rem] w-[3rem] shrink-0 items-center justify-center rounded-full transition-colors duration-150 ${
										isActive
											? 'bg-secondary text-white'
											: isDone
											? 'bg-secondary-100 text-secondary-700'
											: 'bg-gray-200 text-gray-500'
									}`}
								>
									<FontAwesomeIcon
										icon={isDone ? faCheck : item.icon}
										className='h-[1.4rem] w-[1.4rem]'
									/>
								</span>
								<span
									className={`font-colfax text-[1.4rem] leading-snug ${
										isActive
											? 'font-semibold text-secondary-700'
											: isDone
											? 'text-gray-700'
											: 'text-gray-500'
									}`}
								>
									{item.label}
								</span>
							</div>
						</li>
					);
				})}
			</ul>
		</nav>
	);
};
